import { render, staticRenderFns } from "./Opciones.vue?vue&type=template&id=6c2486f8&"
import script from "./Opciones.vue?vue&type=script&lang=ts&"
export * from "./Opciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports